import React from 'react';
import { NavLink } from 'react-router-dom';
import { SubNav } from 'components/navigation/SubNav.style.js';

const DigitalNomadSubNav = (props) => {
  return (
    <SubNav>
      <NavLink exact to='/freelance-web-design-development' activeClassName='current-item'><h1>Freelance Web Design & Development</h1></NavLink><span>/</span>
      <NavLink to='/digital-photo-editing-retouching' activeClassName='current-item'><h1>Digital Photo Editing & Retouching</h1></NavLink>
    </SubNav>
  );
};

export default DigitalNomadSubNav;



// WEBPACK FOOTER //
// ./src/components/navigation/DigitalNomadSubNav.js